import { render } from "./StaticInputsForm.vue?vue&type=template&id=adc59b5c&scoped=true"
import script from "./StaticInputsForm.vue?vue&type=script&lang=js"
export * from "./StaticInputsForm.vue?vue&type=script&lang=js"

import "./StaticInputsForm.vue?vue&type=style&index=0&id=adc59b5c&scoped=true&lang=less"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-adc59b5c"]])

export default __exports__